
class Helper {
    makeToast(show, variant = null, message, title) {
      show.toast(message, {
        // title: `Clone ${variant || "default"}`,
        title: title || 'Alert',
        variant: variant,
        solid: true,
        autoHideDelay: 5000,
      });
   }
}
export default new Helper();
